export const contactNames = ['name', 'email', 'phoneNumber', 'message', 'status'];